export default class UnknownError<Data = unknown> extends Error {
  name = 'エラーが発生しました。しばらくしてから再度お試しください。';

  constructor() {
    super();
  }

}
